var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConnectionMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.06,14.9h0a1.31,1.31,0,1,0,1.3,1.3A1.3,1.3,0,0,0,12.06,14.9Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12,10.8a6.44,6.44,0,0,0-4.57,1.9L7.18,13,8.7,14.52l.3-.29a4.29,4.29,0,0,1,6.12,0l.29.29L16.94,13l-.29-.29A6.46,6.46,0,0,0,12,10.8Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.06,6.48A10.33,10.33,0,0,0,4.49,9.73L4.21,10l1.53,1.53L6,11.24a8.29,8.29,0,0,1,12.06,0l.29.31L19.91,10l-.28-.29A10.36,10.36,0,0,0,12.06,6.48Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConnectionMedium);
export default __webpack_public_path__ + "static/media/connection-medium.2024d503e6dd5175ebb32e0ce9c08827.svg";
export { ForwardRef as ReactComponent };